import{fillOffset as t}from"./fill.mjs.js";function n(n){const o=[0];return t(o,n.length-1),o}export{n as defaultOffset};
